/**
 * Type predicate returning `true` if the provided `value` is `undefined` or `null`.
 */
export function isUndefined<ValueT>(value: ValueT | null | undefined): value is null | undefined {
    return value === undefined || value === null;
}

/**
 * Type predicate returning `true` if the provided `value` is neither `undefined`
 * nor `null` (nor `void`).
 */
export function isDefined<ValueT>(value: ValueT | null | undefined | void): value is ValueT {
    return value !== undefined && value !== null;
}

/**
 * Function applying the provided `mapper` to the provided `value`
 * if it #isDefined, otherwise return provided `defaultValue`.
 */
export function ifDefined<ValueT, ResultT>(value: ValueT | undefined | null | void, mapper: (value: ValueT) => ResultT, defaultValue: ResultT): ResultT;

/**
 * Function applying the provided `mapper` to the provided `value`
 * if it #isDefined, otherwise return `undefined`.
 */
export function ifDefined<ValueT, ResultT>(value: ValueT | undefined | null | void, mapper: (value: ValueT) => ResultT): ResultT | undefined;

export function ifDefined<ValueT, ResultT>(value: ValueT | undefined | null | void, mapper: (value: ValueT) => ResultT, defaultValue?: ResultT): ResultT | undefined {
    return isDefined(value) ? mapper(value) : defaultValue;
}
